import styled from 'particles/themes/styled'
import { theme } from 'theme'

export const BaseEditorContainer = styled.div`
    width: 100%;
    height: 100%;
    padding: ${theme.newSpacing.l};
    box-sizing: border-box;
    background-color: ${theme.newColors.neutral50};
    @media screen and (max-width: 768px) {
        padding: 12px 12px 80px;
    }
    .form-title {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.xxs};
        .title {
            font-weight: ${theme.fontWeight.bold};
            font-size: 20px;
            color: ${theme.newColors.neutral700};
        }
        .subtitle {
            font-size: ${theme.newFontSizes.s};
            line-height: 20px;
            color: ${theme.newColors.neutral500};
        }
    }
    .step-title {
        font-weight: ${theme.fontWeight.bold};
        color: ${theme.newColors.neutral700};
        font-size: ${theme.newFontSizes.l};
        margin-bottom: ${theme.newSpacing.xxxxs};
        .step-number-title {
            display: flex;
            gap: ${theme.newSpacing.xxxxs};
        }
    }
    .step-subtitle {
        max-width: 537px;
        word-wrap: break-word;
    }
    .divider {
        margin: ${theme.newSpacing.l} 0;
    }
    .first-divider {
        width: 100%;
        max-width: 100%;
        margin-top: ${theme.newSpacing.m};
        margin-bottom: ${theme.newSpacing.xl};
    }
    .text-area-container,
    .text-input-container {
        max-width: 755px;
    }
    .textfield-input-container,
    .textarea-input-container,
    .text-area,
    .readonly-text-area,
    .textarea-input,
    .bullet-list-input,
    .counter-and-error,
    .upload-area {
        max-width: 594px;
    }
`
export const ExtraBlockContainer = styled.div`
    max-width: 594px;
    width: 100%;
    background-color: ${theme.newColors.neutral50};
    padding: ${theme.newSpacing.l};
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    margin: ${theme.newSpacing.m} 0;
    box-sizing: border-box;
    @media screen and (max-width: 768px) {
        padding: ${theme.newSpacing.s};
    }
    display: flex;
    flex-direction: column;
    gap: ${theme.newSpacing.l};
    .field-bigger-title {
        width: 100%;
        font-size: ${theme.newFontSizes.m};
        font-weight: ${theme.fontWeight.bold};
        display: flex;
        justify-content: space-between;
        align-items: center;
        svg {
            cursor: pointer;
        }
    }
    .field-title {
        margin-bottom: ${theme.newSpacing.xxxxs};
    }
    .input-area {
        width: 100%;
        height: 38px;
        border: 1px solid ${theme.newColors.neutral200};
        border-radius: 4px;
        padding: 0px 12px;
        box-sizing: border-box;
        margin-bottom: ${theme.newSpacing.xxs};
        input {
            width: 100%;
            border: none;
            height: 100%;
            padding: 0;
            font-size: ${theme.newFontSizes.s};
            &::placeholder {
                color: ${theme.newColors.neutral400};
            }
            &:focus {
                outline: none;
                padding: 0;
            }
            &:-webkit-autofill,
            &:-webkit-autofill:hover,
            &:-webkit-autofill:focus,
            &:-webkit-autofill:active {
                -webkit-box-shadow: 0 0 0 30px ${theme.newColors.neutral50} inset !important;
            }
        }
    }
    .textarea-input {
        position: relative;
        border: 1px solid ${theme.newColors.neutral200};
        border-radius: 4px;
        padding: ${theme.newSpacing.s};
        box-sizing: border-box;
        min-height: 94px;
        textarea {
            width: 100%;
            min-height: 100%;
            border: none;
            resize: none;
            overflow: auto;
            padding: 0;
            font-size: ${theme.newFontSizes.s};
            outline: none;
            color: ${theme.newColors.neutral500};
            &:focus {
                color: ${theme.colors.black};
            }
            &::-webkit-scrollbar {
                display: none;
            }
        }
    }
    .error {
        font-size: ${theme.newFontSizes.xs};
        color: ${theme.newColors.alertError200};
    }
`
export const EditorContentCardContainer = styled.div`
    max-width: 755px;
    .step-title {
        margin-bottom: ${theme.newSpacing.l};
    }
    .section {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.l};
    }
    .link-action-group {
        display: flex;
        gap: 6px;
    }
    .toggle-block {
        display: flex;
        flex-direction: column;
        .link-extend-group {
            margin-left: ${theme.newSpacing.xxxxl};
        }
    }
    .image-uploader-title {
        margin-bottom: ${theme.newSpacing.xxxxs};
    }
    .extra-block {
        margin-top: ${theme.newSpacing.l};
    }
`
export const PayoutSectionCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${theme.newSpacing.l};
`
export const AdditionPayoutCardContainer = styled.div`
    max-width: 594px;
    width: 100%;
    background-color: ${theme.newColors.neutral50};
    padding: ${theme.newSpacing.l};
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    margin: ${theme.newSpacing.m} 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: ${theme.newSpacing.l};
    @media screen and (max-width: 768px) {
        padding: ${theme.newSpacing.s};
    }
    .field-title {
        display: flex;
        justify-content: space-between;
        svg {
            cursor: pointer;
        }
    }
`
